import styles from "./BFS.module.css";
import React from "react";
const BFS = () => {
    return(
        <React.Fragment>
            <div className={styles.container}>
                <div className="wrapperSM wrapperContent">
                    <h2 className={styles.caption}>Die Zweijährige Berufsfachschule (BFS)</h2>
                    <div className="grid">
                        <div className="col-12 lg:col-3">
                            <div className={styles.label}>Aufnahme</div>
                        </div>
                        <div className="col-12 lg:col-9">
                            <div className={styles.content}>
                                <p>Um aufgenommen zu werden darf man zum Stichtag 1. August das 18. Lebensjahr noch nicht vollendet haben. Außerdem muss man über einen qualifizierten Hauptabschluss verfügen oder die Hauptschule in den Hauptfächern Deutsch, Englisch, Mathematik mit mindestens den Noten 3, 3, 4 abgeschlossen haben. Die anderen Fächer müssen auch einen Durchschnitt von mindestens der Note 3 haben.</p>
                                <p>Wenn dies etwas nach unten abweicht, kann ein schriftliches Gutachten der abgebenden Schule helfen, indem die Eignung für die BFS bescheinigt wird.</p>
                            </div>
                        </div>
                        <div className="col-12 lg:col-3">
                            <div className={styles.label}>Unterricht</div>
                        </div>
                        <div className="col-12 lg:col-9">
                            <div className={styles.content}>
                                <p>In unserer BFS mit dem Schwerpunkt Wirtschaft und Verwaltung folgt der Unterricht dem dualen Systemgedanken: Bei etwa 32-34 Wochenstunden Unterricht ist die eine Hälfte den traditionellen Schulfächern vorbehalten: Deutsch, Englisch, Mathematik, Naturwissenschaften, Politik und Wirtschaft, Ethik.</p>
                                <p>Die andere Hälfte des Unterrichts widmet sich den berufsbildenden Lernbereichen mit dem Schwerpunkt Wirtschaft und Verwaltung.</p>
                                <p>Dazu gehören u.a. die Erkundung des Arbeitsmarktes, der Unternehmensformen und ihrer Organisationsstruktur, betriebliche Arbeitsabläufe und Personalvorgänge, das betriebliche Rechnungswesen, Rechtgeschäfte, kaufmännische Texte und Informationen.</p>
                            </div>
                        </div>
                        <div className="col-12 lg:col-3">
                            <div className={styles.label}>Abschluss</div>
                        </div>
                        <div className="col-12 lg:col-9">
                            <div className={styles.content}>
                                <p>Mit der Abschlussprüfung wird nach zwei Jahren die "Mittlere Reife" erworben.</p>
                                <p>Unsere Realabschlussabsolventen haben viele Möglichkeiten der Weiterbildung. Geht man nicht in den Beruf, sondern strebt einen Studiengang an, so kann man bei uns im Haus direkt in die Höhere Berufsfachschule oder die Fachoberschule weitergehen.</p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </React.Fragment>
    )

}
export default BFS;